var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationScaleBalance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M45 66H35V27h2v37h6V27h2v39M45 19h-2v-6c0-1.654-1.346-3-3-3s-3 1.346-3 3v6h-2v-6c0-2.757 2.243-5 5-5s5 2.243 5 5v6",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 72H11v-1c0-3.859 3.141-7 7-7h15v2H18a5.008 5.008 0 00-4.899 4h53.798A5.008 5.008 0 0062 66H47v-2h15c3.859 0 7 3.141 7 7v1M39 14h2v-2h-2zM40 18c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 12c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 26h-4v-2h4a1 1 0 000-2H46v-2h23c1.654 0 3 1.346 3 3s-1.346 3-3 3",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M46 26h13v-2H46zM15 26h-4c-1.654 0-3-1.346-3-3s1.346-3 3-3h23v2H11a1 1 0 000 2h4v2",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M21 26h13v-2H21z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.063 44c.493 3.94 3.865 7 7.937 7s7.444-3.06 7.938-7H10.063zM18 53c-5.514 0-10-4.486-10-10v-1h20v1c0 5.514-4.486 10-10 10z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.999 44a1 1 0 01-.913-1.406l8-18a1 1 0 011.828.812l-8 18a1.002 1.002 0 01-.915.594",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.001 44a1 1 0 01-.915-.594l-8-18a1 1 0 011.828-.812l8 18A1 1 0 0126.001 44M54.063 44c.493 3.94 3.865 7 7.937 7s7.444-3.06 7.938-7H54.063zM62 53c-5.514 0-10-4.486-10-10v-1h20v1c0 5.514-4.486 10-10 10z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.999 44a1 1 0 01-.913-1.406l8-18a1 1 0 011.828.812l-8 18a1.002 1.002 0 01-.915.594",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.001 44a1 1 0 01-.915-.594l-8-18a1 1 0 011.828-.812l8 18A1 1 0 0170.001 44",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M39 62h2v-2h-2zM39 58h2v-2h-2zM39 54h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationScaleBalance;